import { render } from "./Dashboard.vue?vue&type=template&id=acf520f4&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=acf520f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-acf520f4"

export default script